
import Vue from 'vue'

const axios = require("axios")
import config from '@/config'


function resetState(state) {
   Object.assign(state, {
      meals: {},
      mealElements: {},
      meal2mealElementList: {}, // mealId -> list of mealelements
      user2mealList: {}, // userId -> list of meals
      user2date2index2meal: {},
      foods: {},
      foodPortions: {},
      food2foodPortionList: {},
      fractionnings: {},
      user2date2fractionning: {},
      user2surveyFractionningList: {},
      favorites: {},
      user2index2favorites: {},
      nutrients: {},
      nutrientList: [],
      nutdatas: {},
      food2nutrient2nutdata: {},
   })
}

const state = {}
resetState(state)

function sortUserMeals(state, meals) {
   meals.sort(function(id1, id2) {
      let meal1 = state.meals[id1]
      let meal2 = state.meals[id2]
      if (meal1.date < meal2.date) {
         return -1
      } else if (meal1.date > meal2.date) {
         return 1
      } else {
         return meal1.index - meal2.index
      }
   })
}


const mutations = {

   RESET_STATE (state) {
      //console.log('meals/RESET_STATE')
      resetState(state)
   },

   SET_FOOD (state, food) {
      state.foods[food.id] = food
   },

   SET_FOODS (state, foods) {
      foods.forEach(food => {
         state.foods[food.id] = food
      })
   },

   SET_MEAL (state, meal) {
      // update state.meals
      state.meals[meal.id] = meal
   },

   SET_USER_MEALS (state, { userId, meals }) {
      meals.forEach(meal => {
         // update state.meals
         state.meals[meal.id] = meal
         // update state.user2date2index2meal
         if (!state.user2date2index2meal.hasOwnProperty(meal.user)) Vue.set(state.user2date2index2meal, meal.user, {})
         if (!state.user2date2index2meal[meal.user].hasOwnProperty(meal.date)) Vue.set(state.user2date2index2meal[meal.user], meal.date, {})
         Vue.set(state.user2date2index2meal[meal.user][meal.date], meal.index, meal.id)
      })
      let mealList = meals.map(meal => meal.id)
      // sort it by date, index
      sortUserMeals(state, mealList)
      // update state.user2mealList
      Vue.set(state.user2mealList, userId, mealList)
   },

   SET_USER_MEAL (state, { userId, date, index, meal }) {
      if (meal !== null) {
         state.meals[meal.id] = meal
      }
      if (!state.user2date2index2meal.hasOwnProperty(userId)) Vue.set(state.user2date2index2meal, userId, {})
      if (!state.user2date2index2meal[userId].hasOwnProperty(date)) Vue.set(state.user2date2index2meal[userId], date, {})
      if (meal === null) {
         state.user2date2index2meal[userId][date][index] = -1
      } else {
         Vue.set(state.user2date2index2meal[userId][date], index, meal.id)
         if (!state.user2mealList.hasOwnProperty(userId)) Vue.set(state.user2mealList, userId, [])
         let mealList = state.user2mealList[userId]
         if (mealList.indexOf(meal.id) === -1) {
            mealList.push(meal.id)
         }
         // sort it by date, index
         sortUserMeals(state, mealList)
         // update state.user2mealList
         Vue.set(state.user2mealList, userId, mealList)
      }
   },

   CREATE_USER_MEAL (state, meal) {
      // add meal to state.meals
      Vue.set(state.meals, meal.id, meal)
      // add meal to state.user.date2index2meal
      if (!state.user2date2index2meal.hasOwnProperty(meal.user)) Vue.set(state.user2date2index2meal, meal.user, {})
      if (!state.user2date2index2meal[meal.user].hasOwnProperty(meal.date)) Vue.set(state.user2date2index2meal[meal.user], meal.date, {})
      Vue.set(state.user2date2index2meal[meal.user][meal.date], meal.index, meal.id)
      // add meal to state.user2mealList
      if (!state.user2mealList.hasOwnProperty(meal.user)) state.user2mealList[meal.user] = []
      let mealList = state.user2mealList[meal.user]
      mealList.push(meal.id)
      // sort it by date, index
      sortUserMeals(state, mealList)
      Vue.set(state.user2mealList, meal.user, mealList)
   },

   UPDATE_USER_MEAL (state, meal) {
      Vue.set(state.meals, meal.id, meal)
      // then sort state.user2mealList[meal.user] by date, index
      sortUserMeals(state, state.user2mealList[meal.user])
   },

   REMOVE_USER_MEAL (state, meal) {
      // remove it from state.user2mealList
      let index = state.user2mealList[meal.user].indexOf(meal.id)
      Vue.delete(state.user2mealList[meal.user], index)
      // remove it from state.user2date2index2meal
      Vue.delete(state.user2date2index2meal[meal.user][meal.date], meal.index)
      // remove it from state.meals
      Vue.delete(state.meals, meal.id)
   },

   SET_FOODPORTION (state, foodPortion) {
      state.foodPortions[foodPortion.id] = foodPortion
   },

   SET_FOOD_FOODPORTIONS (state, { foodId, foodPortions }) {
      foodPortions.forEach(foodPortion => {
         state.foodPortions[foodPortion.id] = foodPortion
      })
      Vue.set(state.food2foodPortionList, foodId, foodPortions.map(foodPortion => foodPortion.id))
   },

   SET_MEAL_ELEMENTS (state, { mealId, elements }) {
      elements.forEach(element => {
         state.mealElements[element.id] = element
      })
      Vue.set(state.meal2mealElementList, mealId, elements.map(element => element.id))
   },

   ADD_MEAL_ELEMENT (state, mealElement) {
      // add mealElement to state.mealElements
      Vue.set(state.mealElements, mealElement.id, mealElement)
      // add mealElement to state.meal2mealElementList
      if (!state.meal2mealElementList.hasOwnProperty(mealElement.meal)) Vue.set(state.meal2mealElementList, mealElement.meal, [])
      state.meal2mealElementList[mealElement.meal].push(mealElement.id)
   },

   UPDATE_MEAL_ELEMENT (state, mealElement) {
      Vue.set(state.mealElements, mealElement.id, mealElement)
      // force reactivity of state.meal2mealElementList by removing / adding back mealElement into it
      let index = state.meal2mealElementList[mealElement.meal].indexOf(mealElement.id)
      Vue.delete(state.meal2mealElementList[mealElement.meal], index)
      //state.meal2mealElementList[mealElement.meal].push(mealElement.id)
      state.meal2mealElementList[mealElement.meal].splice(index, 0, mealElement.id)
   },

   REMOVE_MEAL_ELEMENT (state, mealElement) {
      Vue.delete(state.mealElements, mealElement.id)
      let index = state.meal2mealElementList[mealElement.meal].indexOf(mealElement.id)
      Vue.delete(state.meal2mealElementList[mealElement.meal], index)
   },

   SET_FRACTIONNING (state, fractionning) {
      // add fractionning to state.fractionnings
      Vue.set(state.fractionnings, fractionning.id, fractionning)
      // add fractionning to state.user2date2fractionning
      if (!state.user2date2fractionning.hasOwnProperty(fractionning.user)) Vue.set(state.user2date2fractionning, fractionning.user, {})
      if (!state.user2date2fractionning[fractionning.user].hasOwnProperty(fractionning.date)) Vue.set(state.user2date2fractionning[fractionning.user], fractionning.date, fractionning.id)
      // update state.user2surveyFractionningList
      if (fractionning.surveyIndex !== null) {
         if (!state.user2surveyFractionningList[fractionning.user]) Vue.set(state.user2surveyFractionningList, fractionning.user, [])
         let surveyFractionningList = state.user2surveyFractionningList[fractionning.user]
         let surveyFractionningDateList = surveyFractionningList.map(id => state.fractionnings[id].date)
         if (surveyFractionningDateList.indexOf(fractionning.date) === -1) {
            surveyFractionningList.push(fractionning.id)
            Vue.set(state.user2surveyFractionningList, fractionning.user, surveyFractionningList)
         }
      }
   },

   UPDATE_FRACTIONNING (state, fractionning) {
      Vue.set(state.fractionnings, fractionning.id, fractionning)
   },

   SET_SURVEY_FRACTIONNINGS (state, { userId, fractionnings }) {
      fractionnings.forEach(fractionning => {
         // add fractionning to state.fractionnings
         Vue.set(state.fractionnings, fractionning.id, fractionning)
         // add fractionning to state.user2date2fractionning
         if (!state.user2date2fractionning.hasOwnProperty(fractionning.user)) Vue.set(state.user2date2fractionning, fractionning.user, {})
         if (!state.user2date2fractionning[fractionning.user].hasOwnProperty(fractionning.date)) Vue.set(state.user2date2fractionning[fractionning.user], fractionning.date, fractionning.id)
      })
      // update state.user2surveyFractionningList
      Vue.set(state.user2surveyFractionningList, userId, fractionnings.map(fractionning => fractionning.id))
   },

   SET_FAVORITES (state, { userId, index, favorites }) {
      // update state.favorites
      favorites.forEach(favorite => {
         Vue.set(state.favorites, favorite.id, favorite)
      })
      // update state.user2index2favorites 
      if (!state.user2index2favorites.hasOwnProperty(userId)) Vue.set(state.user2index2favorites, userId, {})
      if (!state.user2index2favorites[userId].hasOwnProperty(index)) Vue.set(state.user2index2favorites[userId], index, [])
      Vue.set(state.user2index2favorites[userId], index, favorites.map((favorite) => favorite.id))
   },

   ADD_FAVORITE (state, favorite) {
      let userId = favorite.user
      let index = favorite.index
      // update state.favorites
      Vue.set(state.favorites, favorite.id, favorite)
      // update state.user2index2favorites 
      if (!state.user2index2favorites.hasOwnProperty(userId)) Vue.set(state.user2index2favorites, userId, {})
      if (!state.user2index2favorites[userId].hasOwnProperty(index)) Vue.set(state.user2index2favorites[userId], index, [])
      let list = state.user2index2favorites[userId][index]
      list.push(favorite.id)
      Vue.set(state.user2index2favorites[userId], index, list)
   },

   UPDATE_FAVORITE (state, favorite) {
      Vue.set(state.favorites, favorite.id, favorite)
   },

   SET_NUTRIENTS (state, nutrients) {
      // update state.nutrients
      nutrients.forEach(nutrient => {
         Vue.set(state.nutrients, nutrient.nutr_no, nutrient)
      })
      // update state.nutrientList 
      state.nutrientList = nutrients.map(nutrient => nutrient.nutr_no)
   },

   SET_FOOD_NUTDATA (state, nutdatas) {
      // update state.nutdatas & state.food2nutrient2nutdata
      nutdatas.forEach(nutdata => {
         Vue.set(state.nutdatas, nutdata.id, nutdata)
         if (!state.food2nutrient2nutdata.hasOwnProperty(nutdata.food)) Vue.set(state.food2nutrient2nutdata, nutdata.food, {})
         Vue.set(state.food2nutrient2nutdata[nutdata.food], nutdata.nutrient, nutdata.id)
      })
   },
}

const actions = {

   GET_FOOD ({ commit, rootState }, foodId) {
      return axios({
         method: 'get',
         url: `${config.FOODS_URL}${foodId}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_FOOD', response.data)
         return response.data
      })
   },

   GET_FOOD_SEARCH ({ commit, rootState }, text) {
      return axios({
         method: 'get',
         url: `${config.FOODS_URL}?search=${text}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_FOODS', response.data)
         return response.data
      })
   },

   GET_MEAL ({ commit, rootState }, mealId) {
      return axios({
         method: 'get',
         url: `${config.MEALS_URL}${mealId}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let meal = response.data
         commit('SET_MEAL', meal)
         return meal
      })
   },

   GET_USER_DAY_MEALS ({ commit, rootState }, { userId, date }) {
      return axios({
         method: 'get',
         url: `${config.MEALS_URL}?user=${userId}&date=${date}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let userMealsDict = { userId: userId, meals: response.data }
         commit('SET_USER_MEALS', userMealsDict)
         return response.data
      })
   },

   // return null when meal (userId, date, index) does not exist
   GET_USER_MEAL ({ commit, rootState }, { userId, date, index }) {
      return axios({
         method: 'get',
         url: `${config.MEALS_URL}?user=${userId}&date=${date}&index=${index}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let meals = response.data // 0 or 1 meal
         let meal = (meals.length === 0) ? null : meals[0]
         commit('SET_USER_MEAL', { userId: userId, date: date, index: index, meal: meal })
         return meal
      })
   },

   DELETE_USER_MEAL ({ commit, rootState }, meal) {
      return axios({
         method: 'delete',
         url: `${config.MEALS_URL}${meal.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('REMOVE_USER_MEAL', meal)
         return meal
      })
   },
   
   POST_USER_MEAL ({ commit, rootState }, mealToCreate) {
      return axios({
         method: 'post',
         url: config.MEALS_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: mealToCreate,
      })
      .then(function(response) {
         commit('CREATE_USER_MEAL', response.data)
         return response.data
      })
   },
   
   PUT_USER_MEAL ({ commit, rootState }, meal) {
      return axios({
         method: 'put',
         url: `${config.MEALS_URL}${meal.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: meal,
      })
      .then(function(response) {
         commit('UPDATE_USER_MEAL', response.data)
         return response.data
      })
   },

   // fetch portions of a food
   GET_FOODPORTION ({ commit, rootState }, foodPortionId) {
      return axios({
         method: 'get',
         url: `${config.FOOD_PORTIONS_URL}${foodPortionId}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let foodPortion = response.data
         commit('SET_FOODPORTION', foodPortion)
         return response.data
      })
   },

   // fetch portions of a food
   GET_FOOD_FOODPORTIONS ({ commit, rootState }, foodId) {
      return axios({
         method: 'get',
         url: `${config.FOOD_PORTIONS_URL}?food=${foodId}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let foodPortionsDict = { foodId: foodId, foodPortions: response.data }
         commit('SET_FOOD_FOODPORTIONS', foodPortionsDict)
         return response.data
      })
   },

   // fetch meal elements
   GET_MEAL_ELEMENTS ({ commit, rootState }, mealId) {
      return axios({
         method: 'get',
         url: `${config.MEAL_ELEMENTS_URL}?meal=${mealId}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let mealElementsDict = { mealId: mealId, elements: response.data }
         commit('SET_MEAL_ELEMENTS', mealElementsDict)
         return response.data
      })
   },
   
   POST_MEAL_ELEMENT ({ commit, rootState }, mealElement) {
      return axios({
         method: 'post',
         url: config.MEAL_ELEMENTS_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: mealElement,
      })
      .then(function(response) {
         commit('ADD_MEAL_ELEMENT', response.data)
         return response.data
      })
   },
   
   PUT_MEAL_ELEMENT ({ commit, rootState }, mealElement) {
      return axios({
         method: 'put',
         url: `${config.MEAL_ELEMENTS_URL}${mealElement.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: mealElement,
      })
      .then(function(response) {
         commit('UPDATE_MEAL_ELEMENT', response.data)
         return response.data
      })
   },

   DELETE_MEAL_ELEMENT ({ commit, rootState }, mealElement) {
      return axios({
         method: 'delete',
         url: `${config.MEAL_ELEMENTS_URL}${mealElement.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('REMOVE_MEAL_ELEMENT', mealElement)
         return mealElement
      })
   },

   // fetch fractionning
   GET_FRACTIONNING ({ commit, rootState }, { userId, date }) {
      return axios({
         method: 'get',
         url: `${config.FRACTIONNINGS_URL}?user=${userId}&date=${date}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         if (response.data.length === 1) {
            commit('SET_FRACTIONNING', response.data[0])
            return response.data[0]
         } else {
            return null
         }
      })
   },

   // fetch all fractionnings of days of survey
   GET_SURVEY_FRACTIONNINGS ({ commit, rootState }, userId) {
      return axios({
         method: 'get',
         url: `${config.FRACTIONNINGS_URL}?user=${userId}&onlySurveys=true`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_SURVEY_FRACTIONNINGS', { userId: userId, fractionnings: response.data })
         return response.data
      })
   },
   
   POST_FRACTIONNING ({ commit, rootState }, fractionning) {
      return axios({
         method: 'post',
         url: config.FRACTIONNINGS_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: fractionning,
      })
      .then(function(response) {
         commit('SET_FRACTIONNING', response.data)
         return response.data
      })
   },
   
   PUT_FRACTIONNING ({ commit, rootState }, fractionning) {
      return axios({
         method: 'put',
         url: `${config.FRACTIONNINGS_URL}${fractionning.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: fractionning,
      })
      .then(function(response) {
         commit('UPDATE_FRACTIONNING', response.data)
         return response.data
      })
   },

   GET_FAVORITES ({ commit, rootState }, { userId, index }) {
      return axios({
         method: 'get',
         url: `${config.FAVORITES_URL}?user=${userId}&index=${index}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         let favoritesDict = { userId: userId, index: index, favorites: response.data }
         commit('SET_FAVORITES', favoritesDict)
         return response.data
      })
   },

   GET_FAVORITE ({ commit, rootState }, { userId, index, portion, nbportion }) {
      return axios({
         method: 'get',
         url: `${config.FAVORITES_URL}?user=${userId}&index=${index}&portion=${portion}&nbportion=${nbportion}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         return response.data
      })
   },
   
   POST_FAVORITE ({ commit, rootState }, favorite) {
      return axios({
         method: 'post',
         url: config.FAVORITES_URL,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: favorite,
      })
      .then(function(response) {
         commit('ADD_FAVORITE', response.data)
         return response.data
      })
   },
   
   PUT_FAVORITE ({ commit, rootState }, favorite) {
      return axios({
         method: 'put',
         url: `${config.FAVORITES_URL}${favorite.id}/`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
         data: favorite,
      })
      .then(function(response) {
         commit('UPDATE_FAVORITE', response.data)
         return response.data
      })
   },

   GET_NUTRIENTS ({ commit, rootState }) {
      return axios({
         method: 'get',
         url: `${config.NUTRIENTS_URL}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_NUTRIENTS', response.data)
         return response.data
      })
   },

   GET_FOOD_NUTDATA ({ commit, rootState }, foodId) {
      return axios({
         method: 'get',
         url: `${config.NUTDATA_URL}?food=${foodId}`,
         headers: {"Authorization": `JWT ${rootState.authenticationData.token}`},
      })
      .then(function(response) {
         commit('SET_FOOD_NUTDATA', response.data)
         return response.data
      })
   },
}

const getters = {

   // returns a function giving the meals of a user
   userMeals: (state) => (userId) => {
      return state.user2mealList.hasOwnProperty(userId) ? state.user2mealList[userId].map(mealId => state.meals[mealId]) : []
   },

   // returns a function giving the mealElements of a meal
   mealElements: (state) => (mealId) => {
      return state.meal2mealElementList.hasOwnProperty(mealId) ? state.meal2mealElementList[mealId].map(mealElementId => state.mealElements[mealElementId]) : []
   },
}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
   getters,
}



// WEBPACK FOOTER //
// ./src/store/meals/index.js